import AI_Score from "../../assets/images/aiscoresvg.svg";

// Processing Modes
export const PROCESSING_MODES = Object.freeze({
  AI: "ai",
  NON_AI: "non-ai",
});

// Priority Levels (documented for clarity)
export const PRIORITY = Object.freeze({
  NORMAL: 1,
  HIGH: 2,
});

// Test Configurations
export const TESTS_CONFIG = [
  // Speaking
  { test_name: "Read Aloud", short_name: "RA", priority_level: PRIORITY.HIGH, processing_mode: PROCESSING_MODES.AI },
  { test_name: "Repeat Sentence", short_name: "RS", priority_level: PRIORITY.HIGH, processing_mode: PROCESSING_MODES.AI },
  { test_name: "Describe Image", short_name: "DI", priority_level: PRIORITY.HIGH, processing_mode: PROCESSING_MODES.AI },
  { test_name: "Re-tell Lecture", short_name: "RL", priority_level: PRIORITY.HIGH, processing_mode: PROCESSING_MODES.AI },
  { test_name: "Answer Short Question", short_name: "ASQ", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.AI },
  { test_name: "Summarize Group Discussion", short_name: "SGD", priority_level: PRIORITY.HIGH, processing_mode: PROCESSING_MODES.AI },
  { test_name: "Respond to a situation", short_name: "RTS", priority_level: PRIORITY.HIGH, processing_mode: PROCESSING_MODES.AI },

  // Writing
  { test_name: "Summarize Written Text", short_name: "SWT", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.AI },
  { test_name: "Write Essay", short_name: "WE", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.AI },
  { test_name: "Write Email", short_name: "WE", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.AI },

  // Reading
  { test_name: "Reading & Writing: Fill in the Blanks", short_name: "FIB", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.NON_AI },
  { test_name: "Multiple Choice, Multiple Answers", short_name: "MCM", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.NON_AI },
  { test_name: "Re-order Paragraphs", short_name: "ROP", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.NON_AI },
  { test_name: "Reading: Fill in the Blanks", short_name: "FIB", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.NON_AI },
  { test_name: "Multiple Choice, Single Answer", short_name: "MCS", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.NON_AI },

  // Listening
  { test_name: "Summarize Spoken Text", short_name: "SST", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.AI },
  { test_name: "Listening: Multiple Choice, Multiple Answers", short_name: "MCM", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.NON_AI },
  { test_name: "Fill in the Blanks", short_name: "FIB", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.NON_AI },
  { test_name: "Highlight Correct Summary", short_name: "HCS", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.NON_AI },
  { test_name: "Listening: Multiple Choice, Single Answer", short_name: "MCS", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.NON_AI },
  { test_name: "Select Missing Word", short_name: "SMW", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.NON_AI },
  { test_name: "Highlight Incorrect Words", short_name: "HIW", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.NON_AI },
  { test_name: "Write From Dictation", short_name: "WFD", priority_level: PRIORITY.NORMAL, processing_mode: PROCESSING_MODES.AI },
];

export const CircularScoreProgressData1 = [
  {
    id: 1,
    CircularScoreProgress: [
      {
        key: "Reading",
        HeaderBgColor: "#AD826E",
        Title: "Reading",
        score: "3",
        totalScore: "10",
        progressColorFilled: "#AD826E",
        progressColorUnfilled: "#E5DAFF",
        scoreColor: "#AD826E",
      },
      {
        key: "Listening",
        HeaderBgColor: "#868EAF",
        Title: "Listening",
        score: "8",
        totalScore: "10",
        progressColorFilled: "#868EAF",
        progressColorUnfilled: "#E5DAFF",
        scoreColor: "#868EAF",
      },
    ],
  },
];

export const CircularScoreProgressData2 = [
  {
    id: 1,
    CircularScoreProgress: [
      {
        key: "Speaking",
        HeaderBgColor: "#49D7F2",
        Title: "Speaking",
        score: "7",
        totalScore: "10",
        progressColorFilled: "#49D7F2",
        progressColorUnfilled: "#E5DAFF",
        scoreColor: "#49D7F2",
      },
      {
        key: "Writing",
        HeaderBgColor: "#FF5D5D",
        Title: "Writing",
        score: "6",
        totalScore: "10",
        progressColorFilled: "#FF5D5D",
        progressColorUnfilled: "#E5DAFF",
        scoreColor: "#FF5D5D",
      },
    ],
  },
];

export const skillsData = [
  {
    title: "Speaking",
    score: 100,
    progressColor: "#49D7F2",
  },
  {
    title: "Writing",
    score: 100,
    progressColor: "#FF5D5D",
  },
  {
    title: "Reading",
    score: 100,
    progressColor: "#AD826E",
  },
  {
    title: "Listening",
    score: 100,
    progressColor: "#868EAF",
  },
];

export const EnablingSkillsData = [
  {
    title: "Grammar",
    skill: 'grammar',
    score: 23,
    progressColor: "#996CFE",
  },
  {
    title: "Oral Fluency",
    skill: 'fluency',
    score: 40,
    progressColor: "#996CFE",
  },
  {
    title: "Pronounciation",
    skill: 'pronounciation',
    score: 75,
    progressColor: "#996CFE",
  },
  {
    title: "Spelling",
    skill: 'spelling',
    score: 34,
    progressColor: "#996CFE",
  },
  {
    title: "Vocabulary",
    skill: 'vocab',
    score: 24,
    progressColor: "#996CFE",
  },
  {
    title: "Written Discourde",
    skill: 'discorude',
    score: 45,
    progressColor: "#996CFE",
  },
];

export const testData = {
  speaking: [
    {
      id: "#1001173",
      question: "Volcano Behaviours",
      questionText: "Question",
      aiScore: true,
      color: "#49D7F2",
      score: "85/100",
      src: AI_Score,
    },
  ],
  writing: [
    {
      id: "#1001174",
      question: "Global Warming Impact",
      questionText: "Question",
      aiScore: false,
      color: "#FF5D5D",
      score: "68/100",
    },
  ],
  reading: [
    {
      id: "#1001175",
      question: "Historical Literature Review",
      questionText: "Question",
      aiScore: false,
      color: "#AD826E",
      score: "74/90",
    },
  ],
  listening: [
    {
      id: "#1001176",
      question: "Modern Music Trends",
      questionText: "Question",
      aiScore: true,
      color: "#868EAF",
      score: "90/100",
      src: AI_Score,
    },
  ],
};

export const shortNamesMap = {
    "Read Aloud": "RA",
    "Repeat Sentence": "RS",
    "Describe Image": "DI",
    "Re-tell Lecture": "RL",
    "Respond to a situation": "RTS",
    "Answer Short Question": "ASQ",

    "Summarize Written Text": "SWT",
    "Write Essay": "WE",
    "Write Email": "WE",

 
    "Reading & Writing: Fill in the Blanks": "FIB",
    "Multiple Choice, Multiple Answers": "MCM",
    "Re-order Paragraphs": "ROP",
    "Reading: Fill in the Blanks": "FIB",
    "Multiple Choice, Single Answer": "MCS",

  
    "Summarize Spoken Text": "SST",
    "Listening: Multiple Choice, Multiple Answers": "MCM",
    "Fill in the Blanks": "FIB",
    "Write from Dictation": "WFD",
    "Highlight Correct Summary": "HCS",
    "Highlight Incorrect Words": "HIW",
    "Listening: Multiple Choice, Single Answer": "MCS",
    "Select Missing Word": "SMW",
  };

  export const SpeakingQuestionNames = [
    "Read Aloud",
    "Repeat Sentence",
    "Describe Image",
    "Re-tell Lecture",
    "Answer Short Question",
    "Summarize Group Discussion",
    "Respond to a situation",
  ];
  
  export const WritingQuestionNames = ["Summarize Written Text", "Write Essay", "Write Email"];
  
  export const ReadingQuestionNames = [
    "Reading & Writing: Fill in the Blanks",
    "Multiple Choice, Multiple Answers",
    "Re-order Paragraphs",
    "Reading: Fill in the Blanks",
    "Multiple Choice, Single Answer",
  ];
  
  export const ListeningQuestionNames = [
    "Summarize Spoken Text",
    "Listening: Multiple Choice, Multiple Answers",
    "Fill in the Blanks",
    "Highlight Correct Summary",
    "Listening: Multiple Choice, Single Answer",
    "Select Missing Word",
    "Highlight Incorrect Words",
    "Write from Dictation",
  ];

 export const MergedTestsForScoring = {
    'Speaking': [
      'Read Aloud', 'Repeat Sentence', 'Describe Image', 'Re-tell Lecture', 'Answer Short Question', 'Summarize Group Discussion', 'Respond to a situation'
    ],
    'Writing': [
      'Summarize Written Text', 'Write Essay', 'Summarize Spoken Text', 'Write from Dictation'
    ],
    'Reading': [
      'Summarize Written Text', 'Reading & Writing: Fill in the Blanks', 'Multiple Choice, Multiple Answers', 'Re-order Paragraphs', 'Reading: Fill in the Blanks', 'Multiple Choice, Single Answer', 'Highlight Correct Summary', 'Highlight Incorrect Words'
    ],
    'Listening': [
      'Repeat Sentence', 'Re-tell Lecture', 'Answer Short Question', 'Summarize Group Discussion', 'Summarize Spoken Text', 'Listening: Multiple Choice, Multiple Answers', 'Fill in the Blanks', 'Highlight Correct Summary', 'Highlight Incorrect Words', 'Listening: Multiple Choice, Single Answer', 'Select Missing Word', 'Write from Dictation'
    ]
  };

  export const MergedTestsForScoringCore = {
    'Speaking': [
      'Read Aloud', 'Repeat Sentence', 'Describe Image', 'Answer Short Question', 'Respond to a situation'
    ],
    'Writing': [
      'Summarize Written Text', 'Write Essay', 'Reading & Writing: Fill in the Blanks', 'Summarize Spoken Text', 'Fill in the Blanks', 'Write from Dictation'
    ],
    'Reading': [
      'Read Aloud', 'Summarize Written Text', 'Reading & Writing: Fill in the Blanks', 'Multiple Choice, Multiple Answers', 'Re-order Paragraphs', 'Reading: Fill in the Blanks', 'Multiple Choice, Single Answer', 'Highlight Incorrect Words'
    ],
    'Listening': [
      'Repeat Sentence', 'Answer Short Question', 'Respond to a situation', 'Summarize Spoken Text', 'Listening: Multiple Choice, Multiple Answers', 'Fill in the Blanks', 'Highlight Incorrect Words', 'Listening: Multiple Choice, Single Answer', 'Select Missing Word', 'Write from Dictation'
    ]
  };
